import { SwitchButtonTheme as DefaultSwitchButtonTheme } from "@acin.reactjs/acin-ui/switchButton";
import { ComponentCSSStyle } from "@acin.reactjs/acin-ui/theme";
import { DefaultTheme } from "styled-components";
import { AppMediaQueries } from "./BreakpointsTheme";

const SwitchButtonTheme = (
  theme: DefaultTheme,
): ComponentCSSStyle<DefaultSwitchButtonTheme> => ({
  variants: {
    public: {
      group: {
        borderColor: theme.palette.secondary[500],
        [AppMediaQueries.maxTablet]: {
          height: "40px",
        },
      },
      option: {
        animation: {
          backgroundColor: theme.palette.secondary[500],
        },
        root: {
          fontSize: "16px",
          lineHeight: "18px",

          [AppMediaQueries.maxTablet]: {
            height: "32px",
          },
        },
      },
      focused: {
        option: {
          root: {
            color: theme.palette.common.black,
            boxShadow: `0 0 0 2px ${theme.palette.secondary[500]}`,
          },
        },
      },
      hovered: {
        option: {
          root: {
            color: theme.palette.common.black,
          },
        },
      },
      selected: {
        option: {
          root: {
            color: theme.palette.common.black,
          },
        },
      },
      disabled: {
        group: {
          borderColor: theme.palette.greys[100],
        },
        option: {
          root: {
            color: theme.palette.greys[600],
            "&[aria-checked='true']": {
              backgroundColor: theme.palette.greys[100],
            },
          },
        },
      },
    },
  },
});

export default SwitchButtonTheme;
